"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createDashboardReactiveMap = void 0;

var tslib_1 = require("tslib");

var dashboard_constants_1 = require("@hopin-team/dashboard-constants");

var react_core_1 = require("@slicesjs/react-core");

var reactive_map_launchdarkly_1 = require("@slicesjs/reactive-map-launchdarkly");

var LDClient = (0, tslib_1.__importStar)(require("launchdarkly-js-client-sdk"));

var analytics_client_1 = require("./analytics-client");

var authentication_1 = require("./authentication");

var event_slug_1 = require("./event-slug");

var org_id_1 = require("./org-id");

var pusher_client_1 = require("./pusher-client");

var urql_client_1 = require("./urql-client");

var utils_1 = require("./utils");

var defaultErrorHandler = function defaultErrorHandler(error) {
  return console.error('Error creating Dashboard reactive map\n', error);
};

var createDashboardReactiveMap = function createDashboardReactiveMap(_a) {
  var clientPackageDetails = _a.clientPackageDetails,
      _b = _a.onAsyncError,
      onAsyncError = _b === void 0 ? defaultErrorHandler : _b,
      pusherClientOption = _a.pusherClient,
      urlInterface = _a.urlInterface;
  var reactiveMap = new react_core_1.ReactiveMap({
    allowedKeys: ['feature_flags', 'i18n_locale', 'org_id', 'event_id', 'user', 'event_slug', 'user_auth_token'],
    allowedContextKeys: ['analytics_client', 'launchdarkly_client', 'urql_client', 'pusher_client']
  });

  var redirectToLogin = function redirectToLogin() {
    var LOGIN_URL = "".concat((0, dashboard_constants_1.getLoginUrl)(), "?redirect_url=").concat(location.href);
    console.info('No SSO token found, redirecting to login');
    location.assign(LOGIN_URL);
  };

  var callErrorLogger = function callErrorLogger(message, error) {
    if (error instanceof Error) {
      onAsyncError(error);
    } else if (typeof error === 'string') {
      onAsyncError(new Error("".concat(message, ": ").concat(error)));
    } else {
      onAsyncError(new Error(message));
    }
  };

  var getAuthTokenValue = function getAuthTokenValue() {
    return (0, tslib_1.__awaiter)(void 0, void 0, void 0, function () {
      var token, userAuthTokenInitialiser, tokenItem, tokenValue, error_1;
      return (0, tslib_1.__generator)(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2,, 3]);

            userAuthTokenInitialiser = (0, authentication_1.createUserAuthTokenInitialiser)({
              clientPackageDetails: clientPackageDetails
            });
            return [4
            /*yield*/
            , reactiveMap.initialise('user_auth_token', userAuthTokenInitialiser)];

          case 1:
            tokenItem = _a.sent();
            tokenValue = tokenItem.get();
            token = tokenValue;
            return [3
            /*break*/
            , 3];

          case 2:
            error_1 = _a.sent();
            redirectToLogin();
            return [3
            /*break*/
            , 3];

          case 3:
            return [2
            /*return*/
            , token];
        }
      });
    });
  };

  reactiveMap.addMapContext('analytics_client', new Promise(function (resolve, reject) {
    try {
      var analyticsClient = (0, analytics_client_1.createAnalyticsClient)();
      resolve(analyticsClient);
    } catch (error) {
      callErrorLogger('Unable to initialise analytics client', error);
      reject(error);
    }
  })).addMapContext('urql_client', new Promise(function (resolve, reject) {
    function createClient() {
      return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
        var authToken, urqlClient, error_2;
        return (0, tslib_1.__generator)(this, function (_a) {
          switch (_a.label) {
            case 0:
              _a.trys.push([0, 2,, 3]);

              return [4
              /*yield*/
              , getAuthTokenValue()];

            case 1:
              authToken = _a.sent();

              if (!authToken) {
                redirectToLogin();
                return [2
                /*return*/
                ];
              } else {
                urqlClient = (0, urql_client_1.createUrqlClient)(authToken, clientPackageDetails);
                resolve(urqlClient);
              }

              return [3
              /*break*/
              , 3];

            case 2:
              error_2 = _a.sent();
              redirectToLogin();
              reject(error_2);
              return [3
              /*break*/
              , 3];

            case 3:
              return [2
              /*return*/
              ];
          }
        });
      });
    }

    createClient();
  })).addMapContext('pusher_client', new Promise(function (resolve, reject) {
    function createClient() {
      return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
        var authToken, pusherClient, error_3;
        return (0, tslib_1.__generator)(this, function (_a) {
          switch (_a.label) {
            case 0:
              _a.trys.push([0, 3,, 4]);

              return [4
              /*yield*/
              , getAuthTokenValue()];

            case 1:
              authToken = _a.sent();

              if (!authToken) {
                redirectToLogin();
                return [2
                /*return*/
                ];
              }

              return [4
              /*yield*/
              , (0, pusher_client_1.createPusherClient)({
                authToken: authToken
              })];

            case 2:
              pusherClient = _a.sent();
              resolve(pusherClient);
              return [2
              /*return*/
              ];

            case 3:
              error_3 = _a.sent();
              callErrorLogger('Unable to initialise pusher client', error_3);
              reject(error_3);
              return [2
              /*return*/
              ];

            case 4:
              return [2
              /*return*/
              ];
          }
        });
      });
    }

    if (pusherClientOption) {
      resolve(pusherClientOption);
    } else {
      createClient();
    }
  })).addMapContext('launchdarkly_client', new Promise(function (resolve, reject) {
    function createLaunchDarkly() {
      var _a;

      return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
        var authToken, organizationId, eventId, eventSlug, userId, ldClient_1;
        return (0, tslib_1.__generator)(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , getAuthTokenValue()];

            case 1:
              authToken = _b.sent();

              if (!authToken) {
                redirectToLogin();
                return [2
                /*return*/
                ];
              } else {
                organizationId = reactiveMap.item('org_id').get();
                eventId = reactiveMap.item('event_id').get();
                eventSlug = reactiveMap.item('event_slug').get();
                userId = (_a = (0, utils_1.getSSOTokenDetails)(authToken)) === null || _a === void 0 ? void 0 : _a.sub.toString();
                ldClient_1 = LDClient.initialize((0, dashboard_constants_1.getLaunchDarklyClientId)(), {
                  kind: 'user',
                  key: organizationId !== null && organizationId !== void 0 ? organizationId : 'dashboard-app',
                  custom: (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, userId && {
                    userId: userId
                  }), eventId && {
                    eventId: eventId
                  }), eventSlug && {
                    eventSlug: eventSlug
                  }), organizationId && {
                    organizationExternalId: organizationId
                  })
                });
                ldClient_1.on('error', function (error) {
                  return callErrorLogger('Launch darkly client encountered an error', error);
                });
                ldClient_1.on('failed', function (error) {
                  callErrorLogger('Unable to initialise launch darkly client', error);
                  reject(error);
                });
                ldClient_1.on('initialized', function () {
                  reactiveMap.item('feature_flags').set(ldClient_1.allFlags());
                  resolve(ldClient_1);
                });
              }

              return [2
              /*return*/
              ];
          }
        });
      });
    }

    createLaunchDarkly();
  }));

  var ldListener = function ldListener(key) {
    return function (keyValue) {
      return (0, tslib_1.__awaiter)(void 0, void 0, void 0, function () {
        var ldClient, authToken, userId, context;

        var _a;

        var _b;

        return (0, tslib_1.__generator)(this, function (_c) {
          switch (_c.label) {
            case 0:
              if (!keyValue) return [3
              /*break*/
              , 3];
              return [4
              /*yield*/
              , reactiveMap.getMapContext('launchdarkly_client')];

            case 1:
              ldClient = _c.sent();
              authToken = reactiveMap.item('user_auth_token').get();
              userId = authToken ? (_b = (0, utils_1.getSSOTokenDetails)(authToken)) === null || _b === void 0 ? void 0 : _b.sub.toString() : null;
              context = ldClient === null || ldClient === void 0 ? void 0 : ldClient.getContext();
              return [4
              /*yield*/
              , ldClient === null || ldClient === void 0 ? void 0 : ldClient.identify((0, tslib_1.__assign)((0, tslib_1.__assign)({}, context), {
                custom: (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, context === null || context === void 0 ? void 0 : context.custom), userId && {
                  userId: userId
                }), (_a = {}, _a[key] = keyValue, _a))
              }))];

            case 2:
              _c.sent();

              _c.label = 3;

            case 3:
              return [2
              /*return*/
              ];
          }
        });
      });
    };
  };

  reactiveMap.item('event_slug').listen(ldListener('eventSlug'));
  reactiveMap.item('org_id').listen(ldListener('organizationExternalId'));
  reactiveMap.item('feature_flags', {
    initialiser: function initialiser() {
      // We return an object with no flags by default at the moment.
      // Bootstrap flags in the future via SSR -> https://docs.launchdarkly.com/sdk/features/bootstrapping#javascript
      return {};
    }
  }).connect('launchdarkly_client', reactive_map_launchdarkly_1.connector);
  reactiveMap.item('org_id', {
    initialiser: (0, org_id_1.createOrgIdInitializer)({
      reactiveMap: reactiveMap,
      urlInterface: urlInterface
    })
  });
  reactiveMap.item('event_slug', {
    initialiser: (0, event_slug_1.createEventSlugInitializer)({
      reactiveMap: reactiveMap,
      urlInterface: urlInterface
    })
  });
  return reactiveMap;
};

exports.createDashboardReactiveMap = createDashboardReactiveMap;